// extracted by mini-css-extract-plugin
export default {"container":"Se4allLogo_container__51BV0","font":"Se4allLogo_font__74Fz1"};